// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unit-of-measure{vertical-align:sub}.blank-text-input{margin:12px 0}
`, "",{"version":3,"sources":["webpack://./src/ReadAndWrite/widgets/EditConfigurationTable/styles.scss"],"names":[],"mappings":"AAAA,iBACE,kBAAmB,CACpB,kBAGC,aAAc","sourcesContent":[".unit-of-measure {\n  vertical-align: sub;\n}\n\n.blank-text-input {\n  margin: 12px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
